module.exports = __webpack_public_path__ + "static/media/FreePriceTagsIcon.2a69ea86.svg";